module.exports = __webpack_public_path__ + "img/game-title.3becced1.png";